module.exports = __webpack_public_path__ + "images/140_2048.jpg";